import {ArticleView} from "../../core/models/interfaces/statistics-dto.interface";

interface TopArticlesTableProps {
    articles: ArticleView[];
}

const TopArticlesTable = ({articles}: TopArticlesTableProps) => (
    <div className="flex flex-col">
        <h2 className="text-2xl text-on-surface font-semibold mb-4">Najpopularniejsze artykuły</h2>
        <div className="border-b border-gray-200">
            <div className="flex justify-between py-2 text-sm text-on-surface/60 font-semibold">
                <span>Artykuł</span>
                <span>Wyświetlenia</span>
            </div>
        </div>
        {[...articles].sort((e1,e2) => e2.views - e1.views).map((article) => (
            <div key={article.id}
                 className="flex gap-32 justify-between items-center py-3 border-b border-gray-100 overflow-hidden">
                <span className="text-base text-on-surface font-semibold text-ellipsis">{article.name}</span>
                <span className="text-base font-semibold text-on-surface/80 tabular-nums">{article.views}</span>
            </div>
        ))}
    </div>
);

export default TopArticlesTable;
